import React, { useCallback, useState } from 'react';
import cx from 'classnames';

import { Label, MenuItem } from '@atlas/ui';
import { urlCanParse } from 'src/helpers/urlCanParse';
import history from 'src/components/MainRouter/history';

const MenuFooterLinkItem = ({ name, platformSpecificChildren }) => {
  const [isOpened, setIsOpened] = useState(false);

  const handleMenuToggle = useCallback(() => {
    setIsOpened(isOpened => !isOpened);
  }, [])

  const menuTitleClassName = cx('menu-title', { active: isOpened })

  return (
    <div className="user-profile-group-item" key={name}>
      <MenuItem
        key={name}
        onClick={handleMenuToggle}
        renderArrow
        text={name}
        className={menuTitleClassName}
      />

      {
        isOpened && (
          <>
            {platformSpecificChildren?.map(({location, name}) =>
              !location || urlCanParse(location) ? (
                <div className="menu-item" key={location}>
                  <a
                    className="menu-item__wrapper"
                    href={location}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <div className="menu-item__inner">
                      <Label className="menu-item__text" message={name}/>
                    </div>
                  </a>
                </div>
              ) : (
                <MenuItem
                  key={name}
                  onClick={() => history.push(location)}
                  text={name}
                />
              ),
            )}
          </>
        )
      }
    </div>
  )
}

export default MenuFooterLinkItem;
